import { css } from '@emotion/core'
import React, { type ReactNode } from 'react'

const childItemCss = css`
  list-style: none;
  padding: 0;
  margin: 0;

  & + &,
  &:first-of-type {
    margin-bottom: 4px;
  }
`

type Props = {
  children: ReactNode
}

export default function ChildListItemWrapper({ children }: Props): JSX.Element {
  return (
    <li css={childItemCss} data-testid="child-person">
      {children}
    </li>
  )
}
